export default "__VITE_ASSET__Um8YcMpo__"